import { useEffect } from 'react'

/**
 * Hook to set the page title.
 * Automatically appends " | Options Oracle" to the title.
 * usage: usePageTitle('Dashboard') -> Title: "Dashboard | Options Oracle"
 */
export function usePageTitle(title: string) {
    useEffect(() => {
        document.title = `${title} | Options Oracle`
    }, [title])
}
